<template>
  <div class="box">
    <admin-box-item title="요일별 가격 설정" :disabled="disabled">
      <div class="columns is-multiline">
        <div class="column is-full">
          <admin-form-item label="요일별 가격 설정">
            <lp-radio :val.sync="enable"
                      value_name="value"
                      label_name="label"
                      @onSelect="selEnable"
                      :data="[{label:'사용',value:true},{label:'미사용',value:false}]"></lp-radio>
          </admin-form-item>
          <admin-form-item label="가격 설정" v-if="enable">
            <div v-for="(item, idx) in value" :key="`day_price-${idx}`"
                 style="border:1px solid #dbdbdb;padding:8px;margin-bottom:8px">
              <div class="flex-between" style="margin-bottom:6px">
                <div class="flex-align">
                  <div>적용기간:</div>
                  <span class="select">
                    <select v-model="item.period_type"
                            @change="e=> selectPeriodType(item, e)"
                            style="border:0">
    <!--                  <option value="" disabled selected>주문상태</option>-->
                      <option :value="item.value" v-for="(item,idx) in [{label:'전체',value:1},{label:'기간 지정',value:0}]"
                              :key="'status-'+idx">{{ item.label }}</option>
                    </select>
                  </span>
                  <!--<div>
                    <div class="btn-select-day" @click="$modal.show('datePicker')">날짜 선택</div>
                  </div>-->
                </div>
                <div class="flex-align">
                  <div class="day-price-modify unselect" @click="modifyPriceSetting(idx)">수정</div>
                  <div class="day-price-delete unselect" @click="deletePriceSetting(idx)">삭제</div>
                </div>
              </div>
              <!--<admin-date-picker
                type="daterange"
                :not_before="moment().format('YYYY-MM-DD')"
                :data="item.date_range"
                @setDate="res=>selectDate(item,res)"
                v-if="item.period_type===0"></admin-date-picker>-->
              <div v-if="item.period_type===0" style="margin-bottom:14px;">
                <span class="select-date-range unselect" v-if="!item.date_range" @click="showDateRangeModal(item.date_range, idx)">날짜 선택</span>
                <span class="select-date-range unselect" v-else @click="showDateRangeModal(item.date_range, idx)">{{ item.date_range[0] }}~{{ item.date_range[1] }}</span>
              </div>

              <table>
                <td v-for="(item2, idx2) in item.day_price" :key="`dayitem-${idx2}`" :style="dayItemStyle">
                  <div>{{ convertDay(item2.code) }}</div>
                  <div style="font-size:12px;letter-spacing:-1px">{{ item2.price | currency }}</div>
                </td>
              </table>
            </div>
            <button class="button" style="width:100%" @click="addPriceSetting">+추가</button>
          </admin-form-item>
        </div>
      </div>
    </admin-box-item>

    <modal name="priceSetting" :adaptive="true" height="auto" class="modal-style">
      <div class="box">
        <admin-box-item title="요일별 가격 설정">
          <admin-form-item label="금액 설정">
            <div v-for="(item, item_idx) in selectedDayPrice" :key="`price-setting-${item_idx}`">
              <div class="flex-align" style="margin-bottom:4px">
                <div>{{ convertDay(item.code) }}</div>
                <input class="input"
                       style="width:200px;margin:0 8px"
                       v-model="item.price"
                       @input="e=>inputDayPrice(item, e)"
                       type="number">
                원
              </div>
            </div>
          </admin-form-item>
        </admin-box-item>
        <div class="column is-full flex btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('priceSetting')">취소</button>
          <button class="button is-primary" @click="confirmPriceSetting">확인</button>
        </div>
      </div>
    </modal>

    <modal name="dateRangePicker" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <modal-date-range-picker :date_range="selectedDateRange"
                                 @clickResv="clickResv"
                                 :excludeDateRangeArr="excludeDateRangeArr"
                                 @cancel="$modal.hide('dateRangePicker')"></modal-date-range-picker>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import ModalDateRangePicker from "../../../module/modal/ModalDateRangePicker";

  export default {
    name: "PanelDayPrice",
    components: {
      ModalDateRangePicker,
      LpRadio
    },
    props: {
      enable_day_price: {
        type: Boolean
      },
      product_day_price: {
        type: Array,
        default: function () {
          return []
        }
      },
      price: {
        type: Number
      },
      disabled: {
        type: Boolean
      }
    },
    data() {
      return {
        enable: false, // 요일별 가격 설정 사용여부
        value: [], // 요일별 가격 정보 목록
        selectedDayPrice: [],  // 추가시킬 요일별 가격 정보,
        selectedDayPriceIndex: undefined,
        selectedDateRange: [],
        selectedDateRangeIndex: 0
      }
    },
    created() {
      if (typeof (this.enable_day_price) == "boolean") {
        this.enable = this.enable_day_price;
      }
      if(this.product_day_price.length>0) {
        this.value = this.product_day_price;
      }
      // this.value = this.product_day_price;
    },
    computed: {
      excludeDateRangeArr () {
        let date_range = [];
        for(let i=0; i<this.value.length; i++) {
          if(this.value[i].period_type===0 && this.value[i].date_range) {
            date_range.push(this.value[i].date_range);
          }
        }
        return date_range;
      },
      dayItemStyle() {
        return {
          padding: '4px',
          textAlign: 'center',
          verticalAlign: 'center'
        }
      }
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
        }
      },
      enable_day_price(n) {
        if (typeof (n) == "boolean") {
          this.enable = n;
        }
      },
      'product_day_price'(n) {
        this.value = this.product_day_price;
      },
      value: {
       handler (n) {
         this.$emit('update:product_day_price', this.value);
       },
        deep: true
      }
    },
    methods: {
      showDateRangeModal(date_range, idx) {
        this.selectedDateRangeIndex = idx;
        this.selectedDateRange = date_range;
        this.$modal.show('dateRangePicker');
      },
      clickResv (res) {
        this.value[this.selectedDateRangeIndex].date_range = res;
        let url = this.getUrl(`product/${this.$route.query.id}/product_day_price/${this.value[this.selectedDateRangeIndex].id}`);
        this.patchAPI(url, this.value[this.selectedDateRangeIndex]);
        this.$modal.hide('dateRangePicker');
      },
      patchAPI(url, item) {
        this.$axios.patch(url, item).then(res => {
          if(res.status===200) {
            this.getData();
          }
        })
      },
      getData () {
        let url = this.getUrl(`product/${this.$route.query.id}/product_day_price`);
        this.$axios.get(url).then(res => {
          this.value = this.cloneItem(res.data);
        })
      },
      selectPeriodType(item, e) {
        item.period_type=parseInt(e.target.value);
        let url = this.getUrl(`product/${this.$route.query.id}/product_day_price/${item.id}`);
        this.patchAPI(url, item);
      },
      selectDate (item,res) {
        let date_range = res;
        let start1 = date_range[0];
        let end1 = date_range[1];
        let is_duplicate = false;
        for(let i=0; i<this.value.length; i++) {
          if (this.value[i].period_type === 0 && this.value[i].date_range) {
            let start2 = this.value[i].date_range[0]
            let end2 = this.value[i].date_range[1]
            if (start1 <= end2 && start2 <= end1) {
              this.toast('다른 항목에서 이미 선택된 기간입니다.')
              is_duplicate = true;
              item.date_range = res;
              setTimeout(() => {
                item.date_range = "";
              },100)
              break;
            }
          }
        }
        if(!is_duplicate) {
          item.date_range = res;
          let url = this.getUrl(`product/${this.$route.query.id}/product_day_price/${item.id}`);
          this.patchAPI(url, item);
        }
      },
      // 요일별 가격 설정 수정
      modifyPriceSetting(idx) {
        this.$modal.show('priceSetting');
        this.selectedDayPrice = this.value[idx].day_price;
        this.selectedDayPriceIndex = idx;
      },
      deletePriceSetting(idx) {
        if(this.value[idx].id) {
          let value = {
            id: this.value[idx].id,
            url: `product/${this.$route.query.id}/product_day_price/`,
            title: '가격 설정을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
        else removeIndex(this.value, idx);
      },
      defaultDayPrice() {
        let price = 0;
        if(this.price) {
          price = this.price;
        }
        return [
          {
            code: 0,
            price: price
          },
          {
            code: 1,
            price: price
          },
          {
            code: 2,
            price: price
          },
          {
            code: 3,
            price: price
          },
          {
            code: 4,
            price: price
          },
          {
            code: 5,
            price: price
          },
          {
            code: 6,
            price: price
          }
        ]
      },
      inputDayPrice(item, e) {
        item.price = parseFloat(e.target.value.substr(0, 10));
      },
      // 요일별 가격 설정 추가
      addPriceSetting() {
        this.$modal.show('priceSetting');
        this.selectedDayPrice = this.defaultDayPrice();
      },
      donePriceSetting () {
        this.selectedDayPrice = this.defaultDayPrice();
        this.selectedDayPriceIndex = undefined;
        this.$modal.hide('priceSetting');
        this.$emit('update:product_day_price', this.value);
      },
      // 요일별 가격 설정 추가, 수정
      confirmPriceSetting() {
        // 수정
        if (this.selectedDayPriceIndex !== undefined) {
          this.value[this.selectedDayPriceIndex].day_price = this.selectedDayPrice;

          // patch
          let url = this.getUrl(`product/${this.$route.query.id}/product_day_price/${this.value[this.selectedDayPriceIndex].id}`);
          this.$axios.patch(url, this.value[this.selectedDayPriceIndex]).then(res => {
            if(res.status===200) {
              this.toast('요일별 가격이 수정되었습니다.');
              this.donePriceSetting();
              this.getData();
            }
          })
        }
        // 추가
        else {
          // 적용기간 종류가 전체, 기간 지정인지 확인
          let is_all = find(this.value, 'period_type', 1);
          let period_type = 1;
          if (is_all) {
            period_type = 0;
          }
          let item = {
            day_price: this.selectedDayPrice,
            period_type: period_type,
            date_range: ""
          };
          this.value.push(item);

          // post
          let url = this.getUrl(`product/${this.$route.query.id}/product_day_price`);
          this.$axios.post(url, item).then(res => {
            if(res.status===200) {
              this.toast('요일별 가격이 추가되었습니다.');
              this.donePriceSetting();
              this.getData();
            }
          })
          /*if(this.prod.enable_day_price && this.product_day_price.length>0) {
            for(let idx=0; idx<this.product_day_price.length; idx) {
              let day_price = this.product_day_price[idx];
              if(day_price.period_type===0) {
                if(day_price.date_range==='') {
                  err = '기간 지정을 선택할 경우 날짜를 선택하세요.';
                  break;
                }
              }
            }
          }*/

        }
      },
      // 가격 설정 사용 여부
      selEnable(res) {
        this.$emit('update:enable_day_price', res);
      },
      // 요일 변환
      convertDay(code) {
        switch (code) {
          case 0:
            return '월'
          case 1:
            return '화'
          case 2:
            return '수'
          case 3:
            return '목'
          case 4:
            return '금'
          case 5:
            return '토'
          case 6:
            return '일'
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .btn-select-day
    cursor pointer
    user-select none
    width 64px
    color $primary
    border 1px solid $primary
    border-radius 3px
    font-size 12px
    padding 2px 0
    text-align center

  .day-price-modify
  .day-price-delete
    font-size 14px

  .day-price-modify
    color #999999
    margin-right 6px

  .day-price-delete
    color #db2828

  .select-date-range
    border 1px solid $primary
    color $primary
    border-radius 5px
    padding 2px 6px

</style>
